import { joinPaths } from './joinPaths';

/**
 * Supertype for all valid HTTP request data for a given path.
 *
 * If the path contains parameters, then said parameters must be defined in the
 * `params` property.
 */

class RouteSchemaBuilder {
  constructor(pathPatternPrefix) {
    this.pathPatternPrefix = pathPatternPrefix;
  }

  // TODO: Support defining params struct on a prefix.
  prefix(pathPatternPrefix) {
    return new RouteSchemaBuilder(joinPaths(this.pathPatternPrefix, pathPatternPrefix));
  }
  buildRoute(method) {
    return (pathPattern, schema) => ({
      ...schema,
      method,
      pathPattern: joinPaths(this.pathPatternPrefix, pathPattern)
    });
  }
  get = this.buildRoute('GET');
  post = this.buildRoute('POST');
  put = this.buildRoute('PUT');
  patch = this.buildRoute('PATCH');
  delete = this.buildRoute('DELETE');
}
export const arcApiSchema = new RouteSchemaBuilder('/api');